import { useEffect, useRef } from 'react';

import ErrorsList from '/shared/components/ErrorsList';
import type { ErrorType } from '/shared/components/types';

interface Props {
  errors?: ErrorType[] | null;
  hasErrors: boolean;
  marginTop?: string;
  delayMillisecs?: number | null;
}

function ErrorsScroll({ errors = null, hasErrors = false, marginTop = '-2rem', delayMillisecs = null }: Props) {
  const errorsListRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (hasErrors && errorsListRef.current) {
      if (delayMillisecs === null) {
        errorsListRef.current?.scrollIntoView();
      } else {
        const timeoutId = setTimeout(() => {
          errorsListRef.current?.scrollIntoView();
        }, delayMillisecs);
        return () => clearTimeout(timeoutId);
      }
    }
  }, [hasErrors, errorsListRef, delayMillisecs]);
  if (errors) {
    return (
      <div ref={errorsListRef} style={{ paddingTop: '2rem', marginTop }}>
        <ErrorsList errors={errors} />
      </div>
    );
  }
  return null;
}

export default ErrorsScroll;
